const images = {
  loginLogo: require('../assets/images/displayLogin.png'),
};

export { images };
